import styled from 'styled-components'
import { Button } from '../ui'

export const Form = styled.div`
	margin-top: 20px;
`

export const ButtonGroup = styled.div`
	display: flex;
	gap: 12px;
	margin-top: 30px;
	justify-content: flex-end;
`

export const SaveButton = styled(Button)`
	padding: 10px 20px;
	font-size: 14px;
	background: #10b981;
	border-radius: 16px;
	min-width: 70px;
	height: 36px;
	
	&:hover {
		background: #059669;
	}
`

export const CancelButton = styled(Button)`
	padding: 10px 20px;
	font-size: 14px;
	background: #6b7280;
	border-radius: 16px;
	min-width: 70px;
	height: 36px;
	
	&:hover {
		background: #4b5563;
	}
`